export default __webpack_public_path__ + "static/media/google.edfa2ff1.svg";